import { getToken } from "@/utils/functions/TokenFunction";

export const AuthConfig = () => {
    return {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getToken()}`,

        },
    }
}

export const Config = () => {
    return {
        headers: {
            'Content-Type': 'application/json',

        },
    }
}
